import { render } from "./RestockType.vue?vue&type=template&id=25c10a32"
import script from "./RestockType.vue?vue&type=script&lang=js"
export * from "./RestockType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__